import testHandle from '../../utils/testHandle'
import { Overlay, Wrapper } from './ScoreWordMarkHover.styles'
import { ScoreWordMark, ScoreWordMarkBlack } from '../../assets'

export interface ScoreWordMarkHoverProps {
  height?: number
}

// The two stacked wordmarks are one image to assistive tech, named once on the wrapper.
const ScoreWordMarkHover = ({ height = 24 }: ScoreWordMarkHoverProps) => (
  <Wrapper role="img" aria-label="Score">
    <ScoreWordMarkBlack
      height={height}
      style={{ width: 'auto', display: 'block' }}
      data-testid={testHandle('ScoreWordMarkHover-base')}
    />
    <Overlay>
      <ScoreWordMark
        height={height}
        style={{ width: 'auto', display: 'block' }}
        data-testid={testHandle('ScoreWordMarkHover-overlay')}
      />
    </Overlay>
  </Wrapper>
)

export default ScoreWordMarkHover
